import { withNamespaces } from 'react-i18next';
import {
    Button,
    Spinner,
} from 'reactstrap';

import {
    getAttachmentFilename,
    getAttachmentId,
} from '../../../helpers';

const MessageAttachments = ({
    t,
    attachments = [],
    previewUrls = {},
    downloadingId,
    onDownload,
}) => {
    if (!attachments.length) {
        return null;
    }

    return (
        <div className="mailbox-message-detail__attachments">
            <div className="d-flex flex-wrap">
                {attachments.map((attachment) => {
                    const id = getAttachmentId(attachment);
                    const filename = getAttachmentFilename(attachment);
                    const previewUrl = previewUrls[id];
                    const isDownloading = downloadingId === id;

                    if (!id) {
                        return null;
                    }

                    return (
                        <div
                            key={id}
                            className="mailbox-message-detail__attachment"
                        >
                            {previewUrl ? (
                                <img
                                    src={previewUrl}
                                    alt={filename}
                                    className="mailbox-message-detail__thumb"
                                />
                            ) : (
                                <div className="mailbox-message-detail__thumb is-placeholder">
                                    <i className="mdi mdi-paperclip font-size-24 text-muted" />
                                </div>
                            )}
                            <Button
                                type="button"
                                color="primary"
                                outline
                                className="mailbox-message-detail__download"
                                disabled={isDownloading}
                                onClick={() => onDownload(attachment)}
                            >
                                {isDownloading && (
                                    <Spinner
                                        size="sm"
                                        className="me-1"
                                    />
                                )}
                                {t('Download')}
                            </Button>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default withNamespaces()(MessageAttachments);
